<po-page-default
  [p-breadcrumb]="breadcrumb"
  p-title="Expedição - Alterar Pedido/Armazém - Por Pedido"
>
  <div class="po-row">
    <po-input
      [p-auto-focus]="true"
      class="po-md-3 po-mt-1"
      name="CZ02PEDIDO"
      [(ngModel)]="filtro.CZ02PEDIDO"
      (p-change)="selecaoPedido(1)"
      p-label="Pedido Origem"
    ></po-input>

    <po-input
      class="po-md-3 po-mt-1"
      name="CEE7PEDIDO"
      [(ngModel)]="filtro.CEE7PEDIDO"
      (p-change)="selecaoPedido(2)"
      p-label="PO Number"
    ></po-input>
    
    <po-input
      class="po-md-3 po-mt-1"
      name="CFILTRO"
      [(ngModel)]="filtro.CFILTRO"
      p-label="Código ou Descrição do Produto"
    ></po-input>
    
    <po-button
      class="po-md-3 po-mt-4"
      p-label="Filtrar"
      p-kind="primary"
      (p-click)="consultaPedido()"
    ></po-button>
  </div>

  <po-table class="po-sm-12 po-md-12 po-lg-12"
    [p-height]="500"
    [p-sort]="true"
    [p-striped]="true"
    p-selectable="true"
    [p-columns]="tabelaPrincipalColunas"
    [p-items]="tabelaPrincipalItens"
    p-spacing="small"
  ></po-table>

  <po-divider class="po-md-12"></po-divider>

  <po-input
    class="po-md-3"
    name="CC5NUM"
    [(ngModel)]="CC5NUM"
    (p-change)="selecaoPedido(3)"
    p-label="Pedido Destino"
  ></po-input>

  <po-input
    class="po-md-3"
    name="CC5PEDEXP"
    [(ngModel)]="CC5PEDEXP"
    (p-change)="selecaoPedido(4)"
    p-label="PO Number Destino"
  ></po-input>

  <po-button class="po-md-3 po-mt-3"
    p-label="Transferir Pedido"
    (p-click)="transferePedido()"
  ></po-button>

  <po-button class="po-md-3 po-mt-3"
    p-label="Transferir para Estoque / de Estoque"
    (p-click)="transfereEstoque()"
  ></po-button>
</po-page-default>

<po-modal #transferirPedidoModal p-title="Transferência de Pedido para outro armazém" [p-primary-action]="transferirPedidoAction">
  <form #f="ngForm">
    <po-lookup
      class="po-md-12"
      name="motivoTransferencia"
      [(ngModel)]="motivoTransferencia"
      p-label="Motivo da Transferência"
      p-field-value="CZPRCHAVE"
      p-field-label="CZPRGENERI"
      [p-columns]="zprColumnsFilters"
      [p-field-format]="zprFieldFormaterFilters"
      [p-filter-service]="zprService"
      [p-advanced-filters]="zprAdvancedFilters"
      [p-literals]="{ modalTitle: 'Motivo da Transferência' }"
      [p-required]="true"
      [p-auto-height]="true">
    </po-lookup>
  </form>
</po-modal>
